import React from 'react';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import LinkBranded from 'src/elements/links/Link.branded';
import LinkSimple from 'src/elements/links/Link.simple';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import { palette } from 'src/styles/colors';
import { ConfettiBackground, CulturalFitAction, OurTeamCultureFeatText, OurTeamPurpleSectionContainer, OurTeamText, OurTeamTextList, PurpleBackground } from './ourTeam.purple.styles';

const BENEFITS_LIST = [
  'Remote First',
  'Open collaboration',
  'Continuous learning',
  'Promote from within',
  'Optimize for focus, flexibility & flow'
];

const OurTeamPurpleSection = (): JSX.Element => {
  return (
    <OurTeamPurpleSectionContainer>
      <Heading
        text="Be a part of something worth building"
        size="2.5em"
        sizeSm="1.5em"
        align="center"
        color={palette.white}
      />
      <FadeInAnimationWrapper style={{ display: 'grid', justifySelf: 'center' }}>
        <OurTeamText>
          <Paragraph
            text="Join our team to unlock a new creator middle class"
            align="center"
            color={palette.white}
            size="1.5em"
            sizeSm="1em"
            weight="light"
          />
          <LinkSimple
            justify="center"
            iconPosition="right"
            icon={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.66 15.8" height="11px"><path d="M18.84,8.26A24.57,24.57,0,0,1,15,5.14,11.73,11.73,0,0,1,13.45,1.6l-2.9.8a15,15,0,0,0,2.17,4.65,11.65,11.65,0,0,0,.93,1H0v3H13.65a11.65,11.65,0,0,0-.93.95,15,15,0,0,0-2.17,4.65l2.9.8A12,12,0,0,1,15,13.86a24.73,24.73,0,0,1,3.82-3.12L20.66,9.5Z" transform="translate(0 -1.6)"></path></svg>}
            text="See Open Positions"
            url="/careers"
            smooth={false}
            color="main"
            size="1.4em"
            sizeSm="1em"
          />
        </OurTeamText>
      </FadeInAnimationWrapper>
      <FadeInAnimationWrapper>
        <OurTeamCultureFeatText>
          <Paragraph
            text="We're not looking for a cultural fit, we're looking for a culture add."
            color={palette.white}
            align="center"
            size="1.5em"
            sizeSm="1em"
            weight="light"
          />
        </OurTeamCultureFeatText>
      </FadeInAnimationWrapper>
      <FadeInAnimationWrapper>
        <OurTeamTextList>
          {
            BENEFITS_LIST.map((benefit, index) => (
              <Paragraph
                key={index}
                text={benefit}
                align="center"
                size="1.5em"
                color={palette.white}
                sizeSm="0.875rem"
                weight="light"
              />
            ))
          }
        </OurTeamTextList>
      </FadeInAnimationWrapper>
      <FadeInAnimationWrapper>
        <CulturalFitAction>
          <LinkBranded
            text="Join Our Team"
            url="/careers"
            justify="center"
          />
        </CulturalFitAction>
      </FadeInAnimationWrapper>
      <PurpleBackground>
        <ConfettiBackground />
      </PurpleBackground>
    </OurTeamPurpleSectionContainer>
  )
}

export default OurTeamPurpleSection;
